import React from 'react'

import { ProfileAndSettingsSidebar } from './ProfileAndSettingsSidebar'
import { ProfileAndSettingsTopBar } from './ProfileAndSettingsTopBar'
import { type ProfileAndSettingsProps } from './useProfileAndSettingsState'

export const ProfileAndSettings: React.FC<
  ProfileAndSettingsProps & { variant?: 'navbar' | 'sidebar' }
> = ({ variant = 'navbar', ...props }) => {
  switch (variant) {
    case 'sidebar':
      return <ProfileAndSettingsSidebar {...props} />
    default:
      return <ProfileAndSettingsTopBar {...props} />
  }
}
